import { Profile as ProfileData } from '@news-mono/web-common'
import React from 'react'
import {
    StyledSharingShadow,
    StyledSharingWrap,
} from '../../bauhaus/BauhausHeroCard/BauhausHeroCard.styled'
import { Sharing } from '../../buttons/Sharing/Sharing'
import { BioBlock } from '../../content/BioBlock/BioBlock'
import { StyledProfileWrap, StyledSharing } from './Profile.styled'

export interface SevenNewsProfileProps {
    profile: ProfileData
    profileUrl: string
}

export const SevenNewsProfile: React.FC<SevenNewsProfileProps> = ({
    profileUrl,
    profile,
}: SevenNewsProfileProps) => {
    return (
        <StyledProfileWrap>
            <BioBlock profile={profile} url={profileUrl} title={profile.name} />

            <StyledSharing>
                <StyledSharingWrap>
                    <StyledSharingShadow>
                        <Sharing
                            className="BauhausCardSharing"
                            url={profileUrl}
                            text={profileUrl}
                            isGhostStyle={true}
                            onEvent={() => {}}
                            shareOptions={['facebook', 'twitter', 'email']}
                            isBauhaus={true}
                        />
                    </StyledSharingShadow>
                </StyledSharingWrap>
            </StyledSharing>
        </StyledProfileWrap>
    )
}
